import css from "styled-jsx/css";
import Colors from "/styles/colors";
import {
  WHITE_COLOR_NAME,
  BRAND_DARK_COLOR,
  DARK_WORK_OS_IRIS_COLOR_NAME,
  LIGHT_WORK_OS_IRIS_COLOR_NAME
} from "styles/color-consts";
import {
  LIVE_BOARD_VW_WIDTH,
  BANNER_SIDE_VW_MARGIN,
  LEFT_PANNEL_VW_WIDTH,
  BANNER_VW_WIDTH,
  RIGHT_SECTION_VW_WIDTH,
  RIGHT_SECTION_RIGHT_VW_MARGIN
} from "./live-board-consts";
import { ALWAYS_ON_TOP } from "constants/z-index";

export const componentStyles = css.global`
  .live-board-screen {
    backdrop-filter: blur(10px);
    background-color: rgba(0, 0, 0, 0.1);
    display: flex;
    width: 100%;
    height: 100%;

    .live-board-close {
      position: absolute;
      top: 16px;
      left: 16px;
      cursor: pointer;
    }

    .close-icon {
      margin-right: 12px;
      margin-top: 8px;
      width: 25px;
      height: 20px;
    }

    .live-board-content-wrapper {
      display: flex;
      border-top-left-radius: 12px;
      width: ${LIVE_BOARD_VW_WIDTH + "vw"};
      height: 95%;
      margin-left: 10%;
      margin-top: 5%;
      justify-content: center;
      background: ${Colors[WHITE_COLOR_NAME]};
      .left-pannel {
        width: ${LEFT_PANNEL_VW_WIDTH + "vw"};
        background-color: ${Colors[BRAND_DARK_COLOR]};
        display: flex;
        justify-content: center;
        border-top-left-radius: 12px;
        .monday-logo {
          width: 30px;
          padding-top: 10px;
        }
      }
      .right-section {
        width: ${RIGHT_SECTION_VW_WIDTH + "vw"};
        margin-right: ${RIGHT_SECTION_RIGHT_VW_MARGIN + "vw"};
        .board-title-wrapper {
          display: flex;
          flex-direction: row;
          padding-top: 44px;
          padding-left: 30px;
          gap: 28px;
          align-items: baseline;
          .tag {
            padding: 0 4px;
            margin: 0 2px;
            font-weight: 400;
            font-size: 0.6875rem;
            line-height: 154%;
            border-radius: 2px;
            width: fit-content;
            color: ${Colors[DARK_WORK_OS_IRIS_COLOR_NAME]};
            background-color: ${Colors[LIGHT_WORK_OS_IRIS_COLOR_NAME]};
          }
        }
        .board-views-tab-component {
          padding-top: 20px;
          padding-left: 20px;
          height: 100%;
          overflow: scroll;
          .tabs-component-wrapper {
            height: 100%;
            .tabs-component {
              height: 100%;
              .tabs {
                border-bottom: 1px solid #c3c6d4;
                margin-left: 20px;
                justify-content: space-between;
                .tab-component {
                  &:nth-of-type(4) {
                    margin-right: calc(${LIVE_BOARD_VW_WIDTH + "vw"} - 1000px);
                  }
                  &:nth-of-type(6) {
                    .title-wrapper {
                      .title-and-icon-wrapper {
                        .icon-wrapper {
                          margin-right: 0px;
                        }
                      }
                    }
                  }
                  .title-wrapper {
                    .title-and-icon-wrapper {
                      .icon-wrapper {
                        .picture-icon-wrapper {
                          height: 25px;
                        }
                      }
                    }
                  }
                  &.active {
                    .tab-underline-placeholder {
                      background: #0073ea;
                      height: 2px;
                    }
                  }
                }
              }
              .content {
                height: 75%;
                .tab-component {
                  height: 100%;
                  :hover {
                    background-color: unset;
                  }
                  .embedded-board {
                    .embedded-wrapper {
                      border: unset;
                      .board-header {
                        display: none;
                      }
                    }
                  }
                }
              }
            }
          }
        }
        .banner {
          position: fixed;
          bottom: 5vh;
          right: ${BANNER_SIDE_VW_MARGIN + "vw"};
          z-index: ${ALWAYS_ON_TOP};
          border-radius: 8px;
          width: ${BANNER_VW_WIDTH + "vw"};
        }
      }
    }
  }
`;
